import { ReactNode, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

interface LayoutProps {
  children?: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  console.log("[Layout] Rendering layout component");
  
  useEffect(() => {
    console.log("[Layout] Layout component mounted");
    
    // Check if header and footer are properly rendered in the DOM
    try {
      const navbar = document.querySelector('nav');
      const footer = document.querySelector('footer');
      const main = document.querySelector('main');
      
      console.log("[Layout] DOM elements found:");
      console.log("  - Navbar:", !!navbar);
      console.log("  - Main:", !!main);
      console.log("  - Footer:", !!footer);
      
      // Check if main content has children
      if (main) {
        console.log("  - Main content child count:", main.childNodes.length);
        console.log("  - Main content first child:", main.firstChild ? main.firstChild.nodeName : 'none');
      }
    } catch (error) {
      console.error("[Layout] Error checking layout DOM elements:", error);
    }
    
    return () => {
      console.log("[Layout] Layout component unmounted");
    };
  }, []);
  
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        {children || <Outlet />}
      </main>
      <Footer />
    </div>
  );
};

export default Layout; 